import { useState } from 'react'

export default function OrgSwitcher() {
  const [orgs] = useState([
    { id: 1, name: '北京朝阳校区', type: '直营' },
    { id: 2, name: '上海浦东校区', type: '加盟' },
  ])

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🔄 切换机构</h2>

      <div style={{ background: '#fff', borderRadius: 8, padding: 20 }}>
        <div style={{ marginBottom: 16, color: '#666' }}>选择要管理的机构?</div>
        {orgs.map(o => (
          <div key={o.id} style={{ padding: 16, border: '1px solid #d9d9d9', borderRadius: 8, marginBottom: 12, cursor: 'pointer' }}>
            <div style={{ fontWeight: 500 }}>{o.name}</div>
            <div style={{ fontSize: 12, color: '#999' }}>{o.type}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
